import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  ReportStudioRoute,
  ReportStudioPathName,
} from '@/modules/ta/reportstudio/reportstudio.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${ReportStudioRoute.REPORTSTUDIO}`,
      name: ReportStudioPathName.REPORTSTUDIO,
      component: () =>
        import(/* webpackChunkName: "reportstudio-list" */ './pages/ReportStudioListPage.vue'),
    },
    {
      path: `/${ReportStudioRoute.REPORTS}/templates`,
      name: ReportStudioPathName.REPORTSTUDIO_TEMPLATES,
      component: () =>
        import(
          /* webpackChunkName: "reportstudio-list" */ './pages/ReportStudioTemplatesListPage.vue'
        ),
    },
  ],
  Module.REPORTSTUDIO
);
